// src/api/borrowerPortal/resetPassword.js
import { apiPost } from "../client.js";

const PRODUCTION_RESET_URL = "https://dynesourcer.co.uk/reset-password";

/** Reset link sent to the backend when requesting a password reset email. */
export function getPasswordResetUrl() {
  return PRODUCTION_RESET_URL;
}

/**
 * Request a password reset email (PUBLIC - NO Authorization header).
 *
 * POST /api/method/dynesourcerapi.password_reset.request_password_reset
 * Body: { email, reset_url }
 */
export async function resetPassword(email) {
  const normalizedEmail = String(email || "").trim().toLowerCase();
  if (!normalizedEmail) {
    throw new Error("Email is required");
  }

  const payload = {
    email: normalizedEmail,
    reset_url: getPasswordResetUrl(),
  };

  const response = await apiPost(
    "/api/method/dynesourcerapi.password_reset.request_password_reset",
    payload,
    { Authorization: "" }
  );

  return response?.message ?? response;
}

/**
 * Complete password reset from the emailed link (PUBLIC - NO Authorization header).
 *
 * POST /api/method/frappe.core.doctype.user.user.update_password
 * Body: { key, new_password }
 */
export async function resetPasswordWithKey({ key, new_password }) {
  const payload = {
    key: (key || "").trim(),
    new_password: new_password || "",
  };

  if (!payload.key) throw new Error("Reset key is missing. Please use the link from your email.");
  if (!payload.new_password) throw new Error("New password is required");

  const response = await apiPost(
    "/api/method/frappe.core.doctype.user.user.update_password",
    payload,
    { Authorization: "" }
  );

  return response?.message ?? response;
}
